import { createContext } from "react";


const NavCategories = createContext();

export default NavCategories;